import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { motion } from 'framer-motion';
export function GuaranteeSection() {
  return <section className="py-20 px-4 bg-zinc-950" data-id="element-77">
      <div className="max-w-2xl mx-auto" data-id="element-78">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-zinc-900 border border-green-500/30 rounded-2xl p-10 text-center relative overflow-hidden" data-id="element-79">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-green-500 to-green-700" data-id="element-80" />

          <div className="flex justify-center mb-6" data-id="element-81">
            <div className="bg-green-500/10 p-5 rounded-full" data-id="element-82">
              <ShieldCheck className="w-12 h-12 text-green-500" data-id="element-83" />
            </div>
          </div>

          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-84">
            Garantía de 7 Días
          </h2>

          <p className="text-gray-400 text-lg leading-relaxed max-w-lg mx-auto" data-id="element-85">
            Tenés 7 días de garantía por inconvenientes. Si tuviste un problema
            real con el acceso o descarga,{' '}
            <span className="text-white font-semibold" data-id="element-86">lo resolvemos.</span>
          </p>

          <div className="mt-8 flex items-center justify-center gap-6 text-sm text-zinc-500" data-id="element-87">
            <span data-id="element-88">✓ Sin burocracia</span>
            <span data-id="element-89">✓ Respuesta rápida</span>
            <span data-id="element-90">✓ Acceso garantizado</span>
          </div>
        </motion.div>
      </div>
    </section>;
}